var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3867 8C10.3867 9.32 9.32001 10.3867 8.00001 10.3867C6.68001 10.3867 5.61334 9.32 5.61334 8C5.61334 6.68 6.68001 5.61333 8.00001 5.61333C9.32001 5.61333 10.3867 6.68 10.3867 8Z",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 13.5133C10.3534 13.5133 12.5467 12.1267 14.0734 9.72667C14.6734 8.78667 14.6734 7.20667 14.0734 6.26667C12.5467 3.86667 10.3534 2.48 8.00002 2.48C5.64668 2.48 3.45335 3.86667 1.92668 6.26667C1.32668 7.20667 1.32668 8.78667 1.92668 9.72667C3.45335 12.1267 5.64668 13.5133 8.00002 13.5133Z",
    stroke: "#6E7390",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.59712ad7013df78f3734835f9e0da3a5.svg";
export { ForwardRef as ReactComponent };